import { Component, Inject, OnInit, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserService } from '../../../core/services/user.service';
import { environment } from '../../../../environments/environment';
import { EditUserDialogComponent } from '../../../routes/profile/edit-user-dialog/edit-user-dialog.component';
import { TimeService } from '../../../core/services/time.service';

@Component({
    selector: 'app-header-dialog',
    templateUrl: './header-dialog.component.html',
    styleUrls: ['./header-dialog.component.scss']
})
export class HeaderDialogComponent implements OnInit {
    user: any;
    project: any;
    SERVER_URL = environment.SERVER_URL;
    headerUrl: any;

    constructor(
        private userService: UserService,
        private dialog: MatDialog,
        private router: Router,
        private dialogRef: MatDialogRef<any>,
        public timeService: TimeService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    }

    ngOnInit(): void {
        this.user = this.data.user//this.userService.getCurrentUser()
        if (this.user.headerUrl) {
            this.headerUrl = this.SERVER_URL + 'images' + this.user.headerUrl + '?random=' + this.timeService.timestamp
        } else {
            this.headerUrl = './assets/images/default-user.svg'
        }
    }

    openEditProfileDialog() {

        const dialogRef = this.dialog.open(EditUserDialogComponent, {
            width: '630px',
            data: {
                user: this.user
            }
            // height: '600px',
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                this.user = result
                this.dialogRef.close(result);
            }
        });

    }

    toEditCompany() {
        this.dialogRef.close();
        this.router.navigate(['/profile']);
    }

    cancel() {
        this.dialogRef.close();
    }

    logout() {
        localStorage.clear();
        this.router.navigate(['/auth/login']);
        this.cancel();
    }
}
